<template>
  <div>
    <div class="fixed-result-container2">
      <!--SEARCH-->
      <div class="searchContainer" v-if="!userStatus && !searchedBridge && !searchNumberErr">
        <!--SEARCH INPUT-->
        <div >
          <h4>
            <span>
              <vlt-icon class="Vlt-black Vlt-margin--bottom1" icon="phone-garland"/>
            </span>&nbsp;
            {{$t('message.dashboard.searchNumber.search_bridge_by_number')}}
          </h4>
          <div class="Vlt-grid Vlt-margin--A-bottom2">
            <!--SEARCH INPUT-->
            <div class="Vlt-col Vlt-col--2of4">
              <div>
                <vlt-field :error="termError">
                  <vlt-input
                    id="search-input-icon-button"
                    type="search"
                    v-model="term"
                    :val="term"
                    hint=""
                    :placeholder="$t('message.dashboard.searchNumber.search_number')"
                    :disabled="processing"
                    @input="onChangeField"
                  />
                </vlt-field>
              </div>
            </div>
            <!--SEARCH BUTTON-->
            <div class="Vlt-col Vlt-col--2of4">
              <div class="tooltip-item">
                <vlt-tooltip
                  icon="info"
                  :title="$t('message.search')"
                  class="Vlt-grey"
                  position="top"
                >
                  <vlt-button
                    :spinner="this.processing"
                    name="deleteRecord"
                    secondary
                    app
                    :icon="this.processing ? '' : 'search'"
                    @click="doSearch"
                    :disabled="!!this.termError || this.processing || !this.term || (this.term && this.term.length < 6)"
                  />
                </vlt-tooltip>
              </div>
            </div>

            <!--AUTO JOIN-->
            <div class="Vlt-col Vlt-col--1of4 Vlt-grid--margin-bottom2">
              <div>
                <vlt-checkbox
                  :label="$t('message.dashboard.auto_join')"
                  v-model="autoJoin"
                />

              </div>
            </div>
            <div class="Vlt-grid__separator"><!-- Empty line breaker --></div>
          </div>
          <!--LOADING SPINNER-->
          <div class="Vlt-grid Vlt-margin--A-bottom2">
            <div class="Vlt-col Vlt-col--2of4 Vlt-center">
              <vlt-spinner v-if="loading"></vlt-spinner>
            </div>
          </div>
        </div>
        <!--STATUS ON CALL-->
<!--        <div v-if="userStatus">-->
<!--          {{$t('message.dashboard.status')}}:-->
<!--          <span>-->
<!--          &nbsp;-->
<!--          <span :class="userStatus ? 'Vlt-red' : 'Vlt-green'">-->
<!--            {{$t('message.dashboard.on_call')}}-->
<!--          </span>-->
<!--          <span>-->
<!--            <vlt-icon :class="userStatus ? 'Vlt-red' : 'Vlt-green'" smaller :icon="userStatus ? 'call' : 'phone'"/>-->
<!--          </span>-->
<!--        </span>-->
<!--        </div>-->
      </div>
      <!--TEST RESULT TABLE -->
      <div class="Vlt-grid Vlt-margin--A-bottom2 resultContainer" v-if="!processing" >
        <div class="Vlt-col Vlt-col--2of4 scrollCard" >
          <div
            class="Vlt-grid--margin-top1 Vlt-grid--margin-bottom4"
            v-if="normalizedDataForTable && !loading && (userStatus || searchedBridge || searchNumberErr)"
          >
            <div class="Vlt-card Vlt-bg-white Vlt-card--plain">
              <div class="Vlt-card__content">
                <!--CLOSE BUTTON-->
                <div class="Vlt-right" v-if="!userStatus">
                  <vlt-button
                    destructive
                    small
                    icon="cross-circle"
                    @click="cleanUpSearchResult"
                  />
                </div>
                <!--                SOME RESULT HERE: {{searchNumber}}-->
                <div class="table-result-wrapper">
                  <vlt-table
                    v-if="!loading"
                    :columns="userStatus ? activeCallColumns : resColumns"
                    :rows="[normalizedDataForTable]"
                    :pagination="false"
                    :mobile="true"
                  >
                    <template slot="item" slot-scope="slotProps">
                      <td>{{ slotProps.item.feedNumber }}</td>
                      <td>
                        <div
                          v-if="isEdit(slotProps.item.feedNumber)"
                          :data-id="slotProps.item.feedNumber"
                        >
                          <div class="Vlt-form__element">
                            <div class="Vlt-input">
                              <input
                                type="text"
                                :id="`edit-cell-${slotProps.item.feedNumber}`"
                                v-model="slotProps.item.feedDescription"
                                @blur="onSave"
                                @keyup.enter="onSave"
                                v-focus
                              />
                            </div>
                          </div>
                        </div>
                        <div v-else :id="slotProps.item.feedNumber" @click="onEdit" class="editableCell">
                          {{ slotProps.item.feedDescription }}<span @click="()=> onClickEditIcon(slotProps.item.feedNumber, slotProps.item.feedDescription)"><vlt-icon  smaller icon="edit"/></span>
                        </div>
                      </td>
                      <!--ACTION BUTTON-->
                      <td>
                        <!--JOIN BUTTON-->
                        <div v-if="resultContext === resultContexts.searchedBridgeResult">
                          <vlt-button
                            name="deleteRecord"
                            quaternary
                            app
                            large
                            :id="`d_${slotProps.item.number}`"
                            icon="call"
                            @click="onConnect('fromSearch')"
                            :label="`${$t('message.dashboard.join')}`"
                          />
                        </div>
                        <!--CREATE NEW BUTTON-->
                        <div v-else-if="resultContext === resultContexts.noBridgeResult">
                          <vlt-button
                            name="createNew2"
                            quaternary
                            app
                            large
                            :id="`d_${slotProps.item.number}`"
                            icon="call-outbound"
                            @click="onConnect('fromNoSearchRes')"
                            :label="`${$t('message.dashboard.create_new_conversation')}`" />
                        </div>
                        <!--HANG UP BUTTON-->
                        <div v-else-if="resultContext === resultContexts.activeCallResult">
                          <vlt-button
                            name="hangupCall"
                            destructive
                            app
                            large
                            :id="`d_${slotProps.item.feedNumber}`"
                            :icon="isConnecting ? '' : 'phone-down'"
                            @click="onHangUp(slotProps.item.callId)"
                            :disabled="isConnecting"
                            :spinner="isConnecting"
                            :label="`${$t('message.dashboard.hang_up')}`"
                          />
                        </div>
                      </td>
                      <td v-if="userStatus">
                        {{slotProps.item.feedStatus}}
                      </td>
                      <td v-if="userStatus">
                        <vlt-button
                          name="redial"
                          quaternary
                          app
                          large
                          :id="`d_${slotProps.item.number}`"
                          icon="call-outbound"
                          @click="reDial"
                          :label="`${$t('message.dashboard.redial')}`" />
                      </td>
                    </template>
                  </vlt-table>
                </div>

                <div class="Vlt-grid__separator"><!-- Empty line breaker --></div>
                <!--CAPTIONERS-->
                <div v-if="captionersForCurrentBridge.length">
                  {{$t('message.dashboard.captioners')}}:
                  <!--                    <span v-for="(item, idx) in captionersForCurrentBridge" :key="idx">-->
                  <!--                        {{item.number}} - {{item.name}}{{idx < (captionersForCurrentBridge.length-1) ? ', ' : '' }}-->
                  <!--                    </span>-->
                  <div class="Vlt-badge-group">
                    <vlt-badge
                      v-for="(item, idx) in captionersForCurrentBridge"
                      :key="`${idx}_info_badge`"
                      class="Vlt-margin--bottom1"
                      large
                    >
                      {{item.number}} - {{item.name}}
                    </vlt-badge>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--REFRESH BUTTON-->
        <div class="Vlt-col Vlt-col--2of4">
          <div v-if="!isPollingStatus" class="Vlt-margin--A-bottom2">
            <div class="tooltip-item" >
              <vlt-tooltip
                icon="info"
                :title="$t('message.refresh')"
                position="right"
              >
                <vlt-button
                  name="refresh"
                  secondary
                  app
                  icon="refresh"
                  :tooltipTitle= "$t('message.refresh')"
                  @click="setIsPollingStatus(true)"
                />
              </vlt-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations  } from 'vuex';
import TableCellEdit from './TableCellEdit';
import {
  VltIcon,
  VltButton,
  VltSpinner,
  VltTable,
  VltCallout,
  VltField,
  VltInput,
  VltTooltip,
  VltCheckbox,
  VltBadge,
} from '@vonagevolta/vue';

import {
  MAKE_A_CALL,
  HANG_UP_A_CALL,
  SET_IS_POLLING_STATUS,
  GET_BRIDGE_BY_FEED_NUMBER,
  UPDATE_FEED_DESCRIPTION,
  CLEAN_UP_SEARCH_RES,
  RE_DIAL
} from 'Store/action-types';
import {
    SET_SEARCH_NUMBER_ERR,
} from 'Store/mutation-types';
import _ from 'lodash';

export default {
  name: 'SearchAndResult',
  components: {
    VltIcon,
    VltButton,
    VltSpinner,
    VltTable,
    TableCellEdit,
    VltCallout,
    VltField,
    VltInput,
    VltTooltip,
    VltCheckbox,
    VltBadge
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      }
    }
  },
  props: {},
  data() {
    return {
      resultContexts: {
        noBridgeResult: 'noBridgeResult',
        searchedBridgeResult: 'bridgeResult',
        activeCallResult: 'activeCallResult',
      },
      processing: false,
      term: '',
      validatedNumber: '',
      errorNumberFormat: '',
      termError: null,

      activeCallColumns: [
        { title: 'Stream number', property: 'feedNumber'},
        { title: 'Description', property: 'feedDescription'},
        { title: ''},
        { title: 'Status', property: 'feedStatus'},
        { title: ''},
      ],
      noBridgeColumns: [
        { title: 'Stream number', property: 'number'},
        { title: 'Description'},
        { title: ''},
      ],
      columnsSearchedBridge: [
        { title: 'Stream number', property: 'feedNumber'},
        { title: 'Description', property: 'feedDescription'},
        { title: ''},
      ],
      resColumns: [
          { title: 'Stream number', property: 'feedNumber'},
          { title: 'Description', property: 'feedDescription'},
          { title: ''},
      ],

      pageSize: 10,
      noFoundNumber: null,
      editCell: '',
      initEditValue: '',
      editing: false,
      newNumber: '',
      isConnecting: false,
      autoJoin: false,
      numberFromNoSearchRes: '',
      captionersForCurrentBridge: [],
      searchDescription: '',
      resultContext: '',
      normalizedDataForTable: null,
      contextColumns: '',
    };
  },
  computed: {
    ...mapGetters({
      searchedBridge: 'getSearchedBridge',
      isAdmin: 'isAdmin',
      historyData: 'getHistory',
      userStatus:'getUserStatus',
      inConversation: 'getInConversation',
      userActiveCall: 'getUserActiveCall',
      searchNumberErr: 'getSearchNumberErr',
      loading: 'getLoading',
      isPollingStatus: 'getIsPollingStatus',
    }),
  },
  watch: {
    normalizedDataForTable(newProp) {
      // console.log('NEW normalized data: ', newProp)
    },
    loading(current) {
        // console.log('current LOADING: ', current)
    },
    term(current) {
      // console.log('current term: ', current);
        this.validateNumber(current);
    },
    isPollingStatus(current) {
      // console.log('IS POLLING: ', current)
    },
    searchNumberErr: {
      immediate: true,
      handler(newProp) {
        // console.log('SEARCH ERROR: ', newProp)
        this.captionersForCurrentBridge = [];
        if (newProp) {
          this.numberFromNoSearchRes = newProp.number + '';
          this.resultContext = this.resultContexts.noBridgeResult;
          // this.searchDescription = newProp.description;
          this.normalizedDataForTable  = {...this.normalizeResData(newProp, this.resultContext)};
        }
      },
    },
    searchedBridge (newProp) {
      // console.log('=========== searchedBridge: ', newProp);
      if (newProp && Object.keys(newProp).length) {
        if (newProp.feed) {
          this.numberFromNoSearchRes = newProp.feed.number;
          this.searchDescription = newProp.feed.description;
        } else if (newProp && newProp.bridge) {
          this.setCaptioners(newProp.bridge)
        }
        this.resultContext = this.resultContexts.searchedBridgeResult;
        this.normalizedDataForTable  = {...this.normalizeResData(newProp, this.resultContext)};
      }

    },
    userStatus: {
      immediate: true,
      handler(newProp) {
      // console.log('=========== userStatus: ', newProp);
      },
    },
    inConversation: {
      immediate: true,
      handler(newProp) {
      // console.log('=========== inConversation: ', newProp);
      },
    },
    userActiveCall: {
      immediate: true,
      handler(newProp) {
        // console.log('=========== userActiveCall: ', newProp);
        if (newProp) {
          this.resultContext = this.resultContexts.activeCallResult;
          this.normalizedDataForTable  = this.normalizeResData(newProp, this.resultContext);
          if (newProp && newProp.bridge) {
            this.setCaptioners(newProp.bridge);
          }

        } else if (!newProp || (newProp && Object.keys(newProp).length === 0)) {
            this.captionersForCurrentBridge = [];
            this.resultContext = this.resultContexts.noBridgeResult;
            const tryToSet = this.searchedBridgeResult || this.searchNumberErr || null;
            this.normalizedDataForTable  = this.normalizeResData(tryToSet, this.resultContext);
        }
      },
    },
  },
  methods: {
    ...mapMutations({
      setSearchErr: `${SET_SEARCH_NUMBER_ERR}`,
    }),
    ...mapActions({
      search: `${GET_BRIDGE_BY_FEED_NUMBER}`,
      makeACall: `${MAKE_A_CALL}`,
      hangUpACall: `${HANG_UP_A_CALL}`,
      setIsPollingStatus: `${SET_IS_POLLING_STATUS}`,
      saveFeedDescription: `${UPDATE_FEED_DESCRIPTION}`,
      cleanUpResults: `${CLEAN_UP_SEARCH_RES}`,
      reDialFeed: `${RE_DIAL}`,
    }),
    normalizeResData(data, context) {

      let normalizedData = {
        feedNumber: '',
        feedDescription: '',
        callId: '',
      };
      if (data && data.Message) {
          return normalizedData
      } else if (!data || !Object.keys(data).length) {
        return;
      }
      const initData = _.cloneDeep(data);

      switch (context) {
        case this.resultContexts.activeCallResult:
            normalizedData.feedNumber = initData.call.feedNumber;
            normalizedData.callId = initData.call.callId;
            normalizedData.feedDescription = initData.bridge.feedDescription;
          if (initData.bridge.feedState) {
            if (initData.bridge.feedState === 'completed' && initData.bridge.feedEndReason) {
              normalizedData.feedStatus = initData.bridge.feedEndReason;
            } else {
              normalizedData.feedStatus = initData.bridge.feedState;
            }
            normalizedData.feedStatus = initData.bridge.feedState || '';
          }

          break;
        case this.resultContexts.searchedBridgeResult:
          normalizedData.feedNumber = initData.bridge.feedNumber;
          normalizedData.feedDescription = initData.bridge.feedDescription;
          break;
        case this.resultContexts.noBridgeResult:
          normalizedData.feedNumber = initData.number;
          normalizedData.feedDescription = initData.description || '';
          break;

        default:
          break;
      }
      return normalizedData;
    },
    setCaptioners(bridge) {
      if (bridge && bridge.userCallInfo) {
        this.captionersForCurrentBridge = [];
        bridge.userCallInfo.forEach(
          (el) => {
              this.captionersForCurrentBridge.push( {number: el.userNumber, name: el.name })
          }
        );
      }
    },
    convertSecsToFullTime(secs) {
        let totalSeconds;
        try {
            totalSeconds = parseInt(secs);
        } catch (e) {
          console.error(e);
          return;
        }
        let hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        let minutes = Math.floor(totalSeconds / 60);
        let seconds = totalSeconds % 60;

        minutes = String(minutes).padStart(2, "0");
        hours = String(hours).padStart(2, "0");
        seconds = String(seconds).padStart(2, "0");

        return `${hours}:${minutes}:${seconds}`;
    },
    async doSearch() {
      this.processing = true;
      const term = this.term.trim();
      if (!term || !term.trim()) {
        this.termError = this.$i18n.t('message.dashboard.empty_value');
        this.processing = false;
        return;
      }
      const isValidNumber = this.isValidNumber(term);
      if (this.validatedNumber && isValidNumber) {
          this.termError = ''
          await this.search({ feedNumber: this.validatedNumber, autoJoin: this.autoJoin });
      }

      this.autoJoin = false;
      this.processing = false;
    },
    isValidNumber(term) {
        if (!term) {
          return false;
        }
        const exp = /(?:\(?\+\d{2}\)?\s*)?\d+(?:[ -.]*\d+)*[) ]*$/g;
        const exp2Str = /^(\+)?[0-9]*$/g;
        const expExt = /^([\dp]{0,8})$/g;

        let trimmedNumber = term.trim();
        const extDelim = ',';
        const numParts = trimmedNumber.split(extDelim);
        let ext = null;
        let isValidExt = true;

        if (numParts.length === 2) {
            ext = numParts[1];
            trimmedNumber = numParts[0];
            isValidExt = expExt.test(numParts[1]);

        } else if (numParts.length > 2) {
            console.log('number has more than one comma(ext)');
            return false;
        }

        let cleanNumber = trimmedNumber.replaceAll('(', '');
        cleanNumber = cleanNumber.replaceAll(')', '');
        cleanNumber = cleanNumber.replaceAll(' ', '');
        cleanNumber = cleanNumber.replaceAll('-', '');
        cleanNumber = cleanNumber.replaceAll('.', '');

        const isValid = exp.test(trimmedNumber);
        const isValid2 = exp2Str.test(cleanNumber);

        if (isValid && isValid2 && isValidExt) {
            if (!cleanNumber.startsWith('+') && cleanNumber.length === 10) {
                this.validatedNumber = `1${cleanNumber}`;
            } else if (cleanNumber.startsWith('+')) {
                this.validatedNumber = cleanNumber.replace('+', '');
            } else {
                this.validatedNumber = cleanNumber;
            }
            if (ext) {
                this.validatedNumber = `${this.validatedNumber}${extDelim}${ext}`;
            }

            return true;
        }
        return false;
    },
    validateNumber(number) {
    const check = this.isValidNumber(number);
      if (check) {
          this.termError = '';
      } else {
          this.termError = this.$i18n.t('message.login.error3');
      }
    },
    onChangeField() {
      // clean up errors
      this.termError = null;
    },
    async onHangUp(callId) {
      this.isConnecting = true;
      this.processing = true;
      await this.hangUpACall(callId);
      this.processing = false;
      this.isConnecting = false;
    },
    isEdit(number) {
      return this.editCell === number;
    },
    onEdit(e) {
      const id = e.target.id;
      this.initEditValue = e.target.innerText.trim();
      this.editCell = id;
    },
    onClickEditIcon(id, desc) {
      if (desc) {
        this.initEditValue = desc.trim();
      }

      this.editCell = id;
    },

    onLeaveWithoutSave(e) {
      if (this.editing) {
          this.editing = false;
          return;
      }

      const id = e.target.id;
      const numid  = id.substring(id.lastIndexOf('-') + 1);
      const item = this.searchNumber;
      if (item) {
          item.desc = this.initEditValue;
      }
      this.initEditValue = '';
      this.editCell = '';
    },
    async onSave(e) {
        this.editCell = '';
        this.editing = true;
        const newDescValue = e.target.value.trim();

        if (newDescValue === this.initEditValue) {
          return;
        }
        const id = e.target.id;
        const numId  = id.substring(id.lastIndexOf('-') + 1);
        await this.saveFeedDescription({ description: newDescValue, feedNumber:  numId });
        this.editing = false;
    },
    async onConnect(fromSearch) {
      let feedNumber = '';
      this.isConnecting = true;

      if (fromSearch==='fromSearch' && this.searchedBridge && this.searchedBridge.bridge) {
          feedNumber = this.searchedBridge.bridge.feedNumber;
      }
      else if (fromSearch==='fromNoSearchRes' && this.numberFromNoSearchRes) {
          feedNumber = this.numberFromNoSearchRes;
      } else {
        feedNumber = this.newNumber;
        if (!feedNumber.trim()) {
            return;
        }
      }
      const isValidNumber = this.isValidNumber(feedNumber);
      if (this.validatedNumber && isValidNumber) {
          this.termError = ''
      } else {
        this.isConnecting = false;
        return;
      }

      await this.makeACall(feedNumber);
      this.isConnecting = false;
    },
    formatDate(date) {
      let newDate;
      let toLocalStr;

      if (!date) {
          return '';
      }

        const date2 = date.split('+');
        if (date2 && date2.length < 2) {
            newDate = new Date(date);
            toLocalStr = newDate.toLocaleString();
        } else if (date2 && date2.length === 2) {
            const tZ = date2[1];
            const sub1 = tZ.substring(0,2);
            const sub2 = tZ.substring(2);
            const tzF = `${sub1}:${sub2}`;
            const fDate = `${date2[0]}+${tzF}`;
            newDate = new Date(fDate);
            toLocalStr = newDate.toLocaleString();
        }
        return toLocalStr;
    },
    onDismissErr() {
      this.noFoundNumber = null;
      this.setSearchErr('');
    },
    async cleanUpSearchResult () {
      await this.cleanUpResults();
    },
    async reDial () {
      await this.reDialFeed();
    }

  },
  created() {},
};
</script>

<style scoped lang="scss">
  .paddingRight20 {
    padding-right: 20px;
  }

  .paddingLeft20 {
    padding-left: 28px;
  }

  .flexContainer {
    display: flex;
    align-items: stretch;
    //justify-content: space-between;
  }

  .appBoxWidth {
    width: 380px;
  }

  .stretch-height {
    height: 100%;
  }

  .width100percent {
    width: 100%;
  }

  .Vlt-btn--uppercase {
    text-transform: uppercase;
  }

  .previewContent {
    height: 240px;
    max-height: 240px;
    display: flex;
    flex-direction: column;
  }
  .previewTextContent {
    flex: 1 0 auto;
    overflow: auto;
    max-height: 188px;
    .previewText {
      max-height: 80px;
      overflow: auto;
    }
  }
  .fixed-result-container {
    height: 350px;
  }
  .fixed-result-container2 {
    height: 250px;
    margin-bottom: 10px;
  }
  .Vlt-badge-group .Vlt-badge.Vlt-badge--large {

  }
  .editableCell {
    min-height: 24px;
    z-index: 1000;
    span {
      padding-left: 10px;
    }
  }
  .searchContainer {
    height: 150px;
  }
  .resultContainer {
    height: 250px;
  }
  .scrollCard {
    height: 100%;
    overflow: auto;
  }
  .table-result-wrapper {
    div.Vlt-table table tbody tr{
      td{
        width: 33%;
      }
    }
  }
</style>
